const PROVIDER_PRICES_MULTIPLIER = 100000

module.exports = {
  PROVIDER_PRICES_MULTIPLIER
}
